(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
